<!DOCTYPE html>
<html>
<head>
    <title></title>
    <meta charset="utf-8" />
    <style>
        div.portal-content {
            text-align: center;
            font-size: 0.875em;
            font-family: 'Segoe UI', Verdana, Helvetica, sans-serif;
            margin-top: 30%; /* strange, but alrighty then... */
        }
    </style>
</head>
<body>
    <div class="portal-content">
        Dina processer är ej konfigurerade!
    </div>
</body>
</html>
